import { render, staticRenderFns } from "./update-class.vue?vue&type=template&id=ba5dc41a&"
import script from "./update-class.vue?vue&type=script&lang=js&"
export * from "./update-class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports